// extracted by mini-css-extract-plugin
module.exports = {"theme":"#4285f4"};